import { mergeWith } from "./useDataStoreMiro";


export function convertDataToObject<Type>(data: any): Type {
    const result = mergeWith({}, data, converterCustomizer);
    return result;
}
function converterCustomizer(objValue: any, srcValue: any, key: string, object: any, source: any) {
    if (key.startsWith("_") && key !== "_order") {
        if (srcValue._order) {
            if (!Array.isArray(srcValue._order)) {
                srcValue._order = [];
            }
            const result = [];
            for (const id of srcValue._order) {
                const newItem = srcValue[id];
                if (newItem) {
                    result.push(convertDataToObject(newItem));
                } else {
                    // console.error("missing array item")
                }
            }
            return result;
        } else {
            return Object.values(srcValue);
        }
    }
}
